module.exports = __webpack_public_path__ + "img/label3.c1db82fa.png";